import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { trackEvent } from '@/utils/trackingClient';
import { trackLead } from '@/lib/tracking';

const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=4917620283482&text=Hallo+BEKAJ+BAU%2C%0Aich+interessiere+mich+f%C3%BCr+eine+Bauleistung.%0A%0AIch+m%C3%B6chte+gerne+mehr+erfahren.&type=phone_number&app_absent=0';

const WhatsAppRedirect = () => {
  useEffect(() => {
    let redirected = false;
    const doRedirect = () => {
      if (redirected) return;
      redirected = true;
      window.location.replace(WHATSAPP_URL);
    };

    // Tracking + Race mit 500ms Timeout
    trackLead('whatsapp', null);
    trackEvent('whatsapp_click', {
      event_type: 'click',
      destination_url: WHATSAPP_URL,
      timeoutMs: 500,
    }).finally(doRedirect);

    // Harte Sicherheitsgrenze
    const safety = setTimeout(doRedirect, 800);
    return () => clearTimeout(safety);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBF9F5] px-4">
      <Loader2 className="w-8 h-8 animate-spin text-[#25D366] mb-3" />
      <p className="text-sm text-gray-600" data-testid="whatsapp-redirect">Sie werden zu WhatsApp weitergeleitet…</p>
      <a
        href={WHATSAPP_URL}
        className="mt-3 text-xs text-[#4A331D] underline"
        data-testid="whatsapp-fallback-link"
      >
        Falls nichts passiert: hier klicken
      </a>
    </div>
  );
};

export default WhatsAppRedirect;
